<script>
export default {
    name: 'IconRdvTel'
}
</script>
<template>
    <svg
        class="base-icon icon-rdv-tel"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M27 8v4h10V8h6v4h13v44H8V12h13V8h6zm.035 21.456c-.39-.54-1.273-.622-1.976-.132-1.385.969-3.086 2.602-3.059 3.46.014.418.04.707.134 1.154.134.648.375 1.364.751 2.165.99 2.109 2.796 4.56 5.623 7.386 2.828 2.829 5.278 4.635 7.386 5.626.801.376 1.518.617 2.165.751.447.093.735.12 1.155.134.857.026 2.491-1.677 3.457-3.06.495-.706.417-1.592-.135-1.979a318.275 318.275 0 00-4.296-2.845c-.424-.258-1.027-.191-1.599.11-.115.062-.76.424-1.934 1.087-.888-.209-2.061-1.042-3.52-2.5-1.458-1.459-2.292-2.633-2.502-3.522a182.45 182.45 0 001.087-1.936c.305-.577.374-1.182.106-1.604a330.043 330.043 0 00-2.843-4.295zM21 17h-8v6h38v-6h-8v3h-6v-3H27v3h-6v-3z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
